<template>
  <v-text-field
    v-model="selected"
    label="Valeur dans RMR"
    outlined
    hide-details
  />
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "FinanceMappingReplaceFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
      initialUrlValue: [], // in case we need to load from url params
    });

    // =>  METHODS

    // =>  COMPUTED
    const selected = computed({
      get: () => store.getters["finance/getMappingReplace"],
      set(e) {
        store.dispatch("finance/updateMappingReplace", e);
      },
    });

    // =>  WATCH
    watch(selected, (newValue) => {
      if (page.isInitialized) {
        // Only update user changes, not initialization
        addQueryStringParam({
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: newValue,
          // is_multiple: false,
          // is_integer: false,
          // is_boolean: false,
        });
      }
    });

    // =>  HOOKS
    onMounted(async () => {
      set(
        page,
        "initialUrlValue",
        await synchronizeFilterWithQueryString({
          dispatcher: "finance/updateMappingReplace",
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: selected.value,
          // is_multiple: false,
          // is_integer: false,
          // is_boolean: false,
          // dependsOn: undefined,
        })
      );

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      selected,
    };
  },
};
</script>

<style></style>
